import type { Brief } from "@/terminal/file/value-schemas"

// The Brief's claims, with their positions, grouped into paragraphs: a claim
// that opens a paragraph starts the next group (ADR-0143). A Brief without
// one reads as a single paragraph. This lives apart from value-schemas.ts,
// which loads the Terminal Policy, so the admin File view can run it in the
// browser.
export const briefParagraphs = (claims: Brief["claims"]) =>
  claims.reduce<{ claim: Brief["claims"][number]; index: number }[][]>(
    (paragraphs, claim, index) => {
      if (index === 0 || claim.isParagraphStart) paragraphs.push([])
      paragraphs.at(-1)?.push({ claim, index })
      return paragraphs
    },
    []
  )

// The Brief as plain text, its paragraphs separated by a blank line.
export const briefText = (claims: Brief["claims"]) =>
  briefParagraphs(claims)
    .map((paragraph) => paragraph.map(({ claim }) => claim.text).join(" "))
    .join("\n\n")
